import client from './client'

export interface ServiceProperty {
  name: string
  display_name: string
  type: 'enum' | 'integer' | 'float' | 'boolean' | 'string'
  values?: string[]
  min?: number
  max?: number
  unit?: string
  default?: unknown
}

export interface ServiceDefinition {
  name: string
  description: string
  properties: ServiceProperty[]
}

export interface DeviceProfile {
  id: string
  display_name: string
  category: 'actuator' | 'sensor'
  services: ServiceDefinition[]
  created_at: string
}

export interface DeviceProperties {
  device_id: string
  properties: Record<string, unknown>
  updated_at: string
}

export interface PropertyLogItem {
  id: string
  device_id: string
  property_name: string
  old_value: unknown
  new_value: unknown
  source: string
  created_at: string
}

export interface PropertyHistory {
  device_id: string
  logs: PropertyLogItem[]
}

export interface DeviceProfileCreate {
  id: string
  display_name: string
  category: 'actuator' | 'sensor'
  services: ServiceDefinition[]
}

export interface DeviceProfileUpdate {
  display_name?: string
  category?: string
  services?: ServiceDefinition[]
}

export const deviceProfilesApi = {
  list: () =>
    client.get<DeviceProfile[]>('/device-profiles').then((r) => r.data),

  get: (id: string) =>
    client.get<DeviceProfile>(`/device-profiles/${id}`).then((r) => r.data),

  create: (data: DeviceProfileCreate) =>
    client.post<DeviceProfile>('/device-profiles', data).then((r) => r.data),

  update: (id: string, data: DeviceProfileUpdate) =>
    client.put<DeviceProfile>(`/device-profiles/${id}`, data).then((r) => r.data),

  delete: (id: string) =>
    client.delete(`/device-profiles/${id}`),
}

export const devicePropertiesApi = {
  get: (deviceId: string) =>
    client
      .get<DeviceProperties>(`/devices/${deviceId}/properties`)
      .then((r) => r.data),

  update: (deviceId: string, properties: Record<string, unknown>, apiKey?: string) =>
    client
      .put<DeviceProperties>(
        `/devices/${deviceId}/properties`,
        { properties },
        apiKey ? { headers: { 'X-Device-Key': apiKey } } : {}
      )
      .then((r) => r.data),

  history: (deviceId: string) =>
    client
      .get<PropertyHistory>(`/devices/${deviceId}/properties/history`)
      .then((r) => r.data),

  /** 获取设备自身的属性定义快照（不依赖 Profile） */
  schema: (deviceId: string) =>
    client
      .get<ServiceDefinition[]>(`/devices/${deviceId}/schema`)
      .then((r) => r.data),
}
